/* eslint-disable react/prop-types */
import React, { useState, useMemo } from 'react';

import _ from 'lodash';
import { COPIES } from '../../constants';
import { DEPARTMENT_KEYS, LOCATION_KEYS } from '../../../shared/comeet/comeet_api/constants';
import { jobsDepartments } from '../../../utils/dataFunctions';
import { List } from './components/List';
import { Filters } from './components/Filters';
import { Title } from './components/Title';

import styles from './styles.module.scss';

const { URI } = require('@fiverr-private/futile');

const getDepartment = (value) => Object.keys(DEPARTMENT_KEYS).find((key) => DEPARTMENT_KEYS[key] === value) || '';

const getQueryParams = (serverQueryParams) => {
    let queryParams;
    if (global.location) {
        const uri = new URI(global.location.href);
        queryParams = uri.queryParams;
    } else {
        queryParams = serverQueryParams;
    }
    return queryParams || {};
};

const getInitialLocation = (queryParams) => {
    const locationId = queryParams?.location || '';
    return _.findKey(LOCATION_KEYS, (id) => id === locationId) || '';
};

export const AllPositionsList = ({ comeetPositions, queryParams, teamId, title }) => {
    const query = getQueryParams(queryParams);
    const initialLocation = getInitialLocation(query);
    const teams = jobsDepartments(comeetPositions);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedTeam, setSelectedTeam] = useState(getDepartment(teamId));
    const [selectedLocation, setSelectedLocation] = useState(initialLocation);

    const updateSelectedLocation = (locationName) => {
        setSelectedLocation(locationName);

        const newLocationSearchParam = `location=${LOCATION_KEYS[locationName] || ''}`;
        let newUrl = global.location.href.replace(/location=[a-z]*/, newLocationSearchParam);
        if (!newUrl.includes(newLocationSearchParam)) {
            const queryKey = newUrl.includes('?') ? '&' : '?';
            newUrl += queryKey + newLocationSearchParam;
        }
        global.history.replaceState({}, '', newUrl);
    };

    const filteredPositions = useMemo(
        () =>
            comeetPositions.filter(
                (position) =>
                    position.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
                    position.department.toLowerCase().includes(selectedTeam.toLowerCase()) &&
                    (position.location.city || position.location.name)
                        .toLowerCase()
                        .includes(selectedLocation.toLowerCase())
            ),
        [searchTerm, selectedTeam, selectedLocation, comeetPositions]
    );

    const positions = useMemo(
        () =>
            filteredPositions.reduce((acc, position) => {
                const department = position.department_slug || 'other';

                acc[department] = acc[department] ? [...acc[department], position] : [position];

                return acc;
            }, {}),
        [filteredPositions]
    );

    return (
        <div>
            <div id="positions" className={styles.positionsAnchor}></div>
            {teamId ? <Title title={title} /> : null}

            <div className="page-container">
                <p className={styles.title}>
                    {filteredPositions.length}{' '}
                    {COPIES.openPositions.replace('{teams}', teamId ? COPIES.teams[teamId] : 'all teams')}
                </p>
                <Filters
                    setSearchTerm={setSearchTerm}
                    setTeam={setSelectedTeam}
                    defaultLocation={initialLocation}
                    setLocation={updateSelectedLocation}
                    showTeam={!teamId}
                />
            </div>

            <List teams={teams} positions={positions} allTeamsView={!teamId} />
        </div>
    );
};
